/**
 * Фон под модальными окнами недоступен (`inert` на #root) — и для мыши, и для
 * скринридера. Окна открываются одно поверх другого (панель, на ней диалог),
 * поэтому счётчик общий: фон оживает, когда закрылось последнее.
 *
 * Сами окна рисуются порталом в `document.body`, вне #root, и под `inert` не
 * попадают.
 */
let depth = 0;

export function setAppInert(on: boolean): void {
  depth = Math.max(0, depth + (on ? 1 : -1));
  const root = document.getElementById('root');
  if (root) root.inert = depth > 0;
}

/** Элементы, до которых доходит Tab. */
export const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'summary',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/** Видимые элементы внутри `root`, до которых можно дойти по Tab. */
export function focusables(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    (el) => el.getClientRects().length > 0,
  );
}
